import React from 'react';
import moment from 'moment';
import StyledComponent from '~/components/Styled/Styled';

import getOr from '~/util/getOr';

import css from './GraphQLEventCard.scss';

interface Props {
  event: {
    event_details: {
      tv_listings_by_country_code: {};
    };
    status: string;
    startDate: string;
    endDate: string;
    eventType: string;
  };
}

class GraphQLEventCard extends React.Component<Props> {
  static displayName = 'GraphQLEventCard';

  leagueSlug = getOr(this.props, 'event.league.slug', '');

  renderEventStatus() {
    const { status, event_details, startDate, endDate } = this.props.event;
    switch (status) {
      // eslint-disable-next-line no-case-declarations
      case 'SCHEDULED':
        const gameDate = moment(startDate);
        const finDate = moment(endDate);
        const sameDay = gameDate.format('MMM DD') === finDate.format('MMM DD');
        return (
          <div className={css.statusTitle}>
            {gameDate.format('MMM DD')} {!sameDay ? `- ${finDate.format('DD')}` : ''} &middot;&nbsp;
            {gameDate.format('h:mm a')}
          </div>
        );

      // eslint-disable-next-line no-case-declarations
      case 'IN_PROGRESS':
        const tvStation = getOr(event_details, 'tv_listings_by_country_code.us[0].short_name', '');
        return (
          <div className={`${css.statusTitle} ${css.statusLive}`}>
            Live
            {!!tvStation.content && (
              <div className={`${css.statusTitle} ${css.statusLive}`}>&nbsp;&middot;&nbsp;</div>
            )}
            {tvStation.content}
          </div>
        );

      case 'FINAL':
      case 'CANCELLED':
        return <div className={css.statusTitle}>{status}</div>;
      default:
        return null;
    }
  }

  renderPlayerRecords() {
    return (
      <div>
        <div className={`${css.playerBox} ${css.statusTitle}`}>
          <span>Players</span>
          <span>Total</span>
        </div>
        {getOr(this.props, 'event.playerEventRecords.edges', []).map(elem => {
          const node = getOr(elem, 'node', {});

          return (
            <div className={css.playerRow} key={node.player.id}>
              <span className={css.vertCenter}>
                {node.rank ? (
                  <span className={css.rank}>{`${node.rankTied ? 'T' : ''}${node.rank}`}</span>
                ) : null}
                <img
                  className={css.flagContainer}
                  src={getOr(node, 'player.country.flags[0].url', '')}
                  alt={`Flag of ${node.player.country.name}`}
                />
                {node.player.firstInitialAndLastName}
              </span>
              <span className={css.score}>{node.score ? node.score : '-'}</span>
            </div>
          );
        })}
      </div>
    );
  }

  render() {
    const name = getOr(this.props, 'event.tournamentName', '');

    return (
      <div className={css.resultEventCardContainer}>
        {this.renderEventStatus()}
        <div className={css.eventName}>{name}</div>
        {getOr(this.props, 'event.playerEventRecords.edges', []).length &&
        this.props.event.eventType === 'STROKE_PLAY' &&
        this.props.event.status !== 'SCHEDULED'
          ? this.renderPlayerRecords()
          : null}
      </div>
    );
  }
}

export default StyledComponent(GraphQLEventCard, [css]);
